import { Section } from "components/Common/Section";
import settingsStyles from "../settingsDrawer.module.scss";
import { latestAnalyticsVersion } from "constants/analytics";
import { Button } from "components/Common/Button";
import { AnalyticsConsentModal } from "components/PopupManager/AnalyticsConsentModal";
import { usePortal } from "contexts/PortalContext";

// const configs = entries(ANALYTICS_CONFIG).map(([k, v]) => ({
//   key: k,
//   ...v,
// }));

export const AnalyticsConfigSection = () => {
  const portalProps = usePortal();

  return (
    <Section
      label={"Analytics"}
      className={settingsStyles["entry"]}
      contentClassName={settingsStyles["entry-content"]}
      isSubSection
    >
      <Button
        onClick={() => portalProps.setIsLockedPortalComponentRendered(true)}
        style={{ width: "100%" }}
      >
        Open Consent Modal
      </Button>
      <AnalyticsConsentModal
        portalProps={portalProps}
        showAll
        allowClose
        newestVersion={latestAnalyticsVersion}
      />
      {/* {configs.map((config, i) => {
        const { key, label, description, explanation } = config;
        const defaultValue = false;

        const updater = fpUpdate(
          ["analyticsConsent", key],
          (prev) => !(prev ?? defaultValue)
        );
        const value = get(tempUser, ["analyticsConsent", key]) ?? defaultValue;

        return (
          <Fragment key={i}>
            <SettingsDrawerToggle
              key={key}
              value={value}
              label={label}
              helpTooltip={
                <div>
                  {description}
                  <p>
                    <span className={settingsStyles["explanation-header"]}>
                      Why are we tracking this?
                    </span>
                  </p>
                  {explanation}
                </div>
              }
              onToggle={() => setTempUser(updater)}
              onText={"Enabled"}
              offText={"Disabled"}
            />
          </Fragment>
        );
      })} */}
    </Section>
  );
};
